if (!customElements.get('rb-reviews')) {
  class RbReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rb-rev__track');
      this.slides = Array.from(this.querySelectorAll('.rb-rev__slide'));
      this.dots = Array.from(this.querySelectorAll('.rb-rev__dot'));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      this.querySelectorAll('.rb-rev__more').forEach((btn) => btn.addEventListener('click', () => this.toggle(btn)));
      if (this.track) {
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.sync());
          },
          { passive: true }
        );
      }
      this.measure = () => {
        this.slides.forEach((slide) => {
          const text = slide.querySelector('.rb-rev__text');
          const btn = slide.querySelector('.rb-rev__more');
          if (!text || !btn || slide.classList.contains('is-open')) return;
          btn.hidden = !(text.scrollHeight > text.clientHeight + 1);
        });
      };
      this.measure();
      window.addEventListener('resize', this.measure);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.measure);
    }

    go(index) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const width = this.track.clientWidth || 1;
      const index = Math.round(this.track.scrollLeft / width);
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }

    toggle(btn) {
      const slide = btn.closest('.rb-rev__slide');
      const open = slide.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    }
  }
  customElements.define('rb-reviews', RbReviews);
}